import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import "bootstrap"

import './assets/style.css';
import './assets/simple-sidebar.css';
import './assets/bootstrap.rtl.min.css';

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import store from './store'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import VueNativeSock from "vue-native-websocket-vue3";

import VueLazyLoad from "vue3-lazyload";

const socketOptions= {
    store: store,
    format: 'json',
    reconnection: true, 
    reconnectionAttempts: 999999,
    reconnectionDelay: 5000,
    connectManually: true,
}

createApp(App)
    .use(router)
    .use(VueSweetalert2)
    .use(VueNativeSock,process.env.VUE_APP_API_SOCKET_URL,socketOptions)
    .use(store)
    .use(VueLazyLoad)
    .mount('#app')